module.exports = __webpack_public_path__ + "img/home_icon_peixun_normal.e1042040.png";